import React from 'react';
import Header from '../../Components/Header';
import BusSearch from './BusSearch';

const Bus = () => (
  <>
  <Header></Header>
   <section className='Bus_top_banner'>
      <BusSearch />
    </section>
  <section class="footer_top"> 
		<div class="container">
		<div class="_toprflcont mb-8">
			<div class="_hdrtxt">Quick Links </div>
		</div>
     <div class="col-md-12">
        <div class="d-flex-bus">
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Chandigarh.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Chandigarh</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Pune.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Pune</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Mysore.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Mysore</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Jaipur.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Jaipur</h5>
                </a>
            </div>
            <div class="famous_place">
                <a href="">
                    <div class="place_img">
                    <img src="/assets/images/location/Surat.png" alt="flight" class="img-fluid" />
                </div>
                    <h5>Surat</h5>
                </a>
            </div>
           
           
        </div>
     </div>
           
            
        </div>    
    </section>
  </>
   
);

export default Bus;
